module.exports = __webpack_public_path__ + "static/media/marriage-banner.b65efadb.jpg";